import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/shared/utils.service';
import { PageEvent } from '@angular/material/paginator';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AddEditEventComponent } from './add-edit-event/add-edit-event.component';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { EventDetailsComponent } from './event-details/event-details.component';
import { Event } from '../event.model';
import { User } from 'src/app/auth/user.model';
import { ExportService } from '../../shared/export.service';

@Component({
    selector: 'app-events',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.scss'],
    standalone: false
})
export class EventsComponent implements OnInit {
  pageEvent!: PageEvent;
  searchForm!: FormGroup;
  showSearch: boolean;
  pageSize = 10;
  pageNumber = 1;
  totalSize = 0;
  userID: number;
  eventsList = new Array<any>();
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
    usedOnMobile: boolean | null;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null,
    usedOnMobile: null
  };

  searchValue = "";
  user: User;
  selected = 'usedOnMobile';
  usedOnMobile = null;
  eventId = null; 

  constructor(public dialog: MatDialog, public utils: UtilsService,
              public dataService: DataService,
              private authService: AuthService,
              private route: ActivatedRoute,
              public dialogRef: MatDialogRef<ConfirmDialogComponent>,
              private router: Router,
              private exportService: ExportService) {
                this.showSearch = false;
                this.user = this.authService.getUserData();
                this.userID = this.user.id;
                this.route.queryParams.subscribe((params: Params) => {
                  if (!this.isEmpty(params)) {
                    this.eventId = params.eventId ? params.eventId : null;
                    this.pageNumber = params.pageNumber ? params.pageNumber : 1;
                    this.pageSize = params.pageSize ? params.pageSize : 10;
                    this.searchValue =  params.searchValue ? params.searchValue : "";
                    this.usedOnMobile = params.usedOnMobile;
                    this.selected = params.usedOnMobile === 'true'  ? 'usedOnMobile'  : 'manufacturer';
                    if (params.usedOnMobile === undefined) {
                      if (this.user.type === this.utils.userTypes.Distributor || this.user.type === this.utils.userTypes.DistributorChild) {
                        this.usedOnMobile = true;
                      } else {
                        this.usedOnMobile = null;
                      }
                      this.selected = 'usedOnMobile';
                    }
                  } else {
                    if (this.user.type === this.utils.userTypes.Distributor || this.user.type === this.utils.userTypes.DistributorChild) {
                      this.usedOnMobile = true;
                    }
                  }
                  this.getEvents();
                  if (this.eventId) {
                    this.dataService.get('event/RetrieveEventById/' + this.eventId).then((data: any) => {
                      if (data.statusCode === 200) {
                        this.openEventDetails(data.data);
                      }
                    });
                  }
                });
                }

  ngOnInit(): void {
    this.utils.setTitle('Events');
    this.utils.screenTitle.emit({firstTitle: 'Events', firstRoute: '/events'});
    this.searchForm = new FormGroup({
      search: new FormControl(this.searchValue),
    });

    if (this.searchValue) {
      this.showSearch = true;
    }

    this.searchForm.get('search')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.searchValue !== '') {
        setTimeout(() => this.clearSearch(), 0);
      }
    });
  }

  moveToUsedOnMobile(id: any) {
    this.dataService.put('event/UpdateUsedOnMobile', {
      usedOnMobile : true,
      eventId: id,
    }).then((data: any) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Used on mobile enabled successfully.',
            buttonText: 'Ok'
          }
        });
        this.getEvents();
      }
    });
  }

  moveToNotUsedOnMobile(id: any) {
    this.dataService.put('event/UpdateUsedOnMobile', {
      usedOnMobile : false,
      eventId: id,
    }).then((data: any) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Used on mobile disabled successfully',
            buttonText: 'Ok'
          }
        });
        this.getEvents();
      }
    });
  }

  moveToUnUsedOnMobile(id: any) {
    this.dataService.put('event/UpdateUsedOnMobile', {
      usedOnMobile : false,
      eventId: id,
    }).then((data: any) => {
      if (data.statusCode === 200) {
        this.getEvents();
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Used on mobile disabled successfully',
            buttonText: 'Ok'
          }
        });
      }
    });
  }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
    this.router.navigate(['/events'], { queryParams: this.queryParams });
  }

  handleSearchClick() {
    if (this.showSearch) {
      this.doSearch();
    } else {
      this.showSearch = true;
    }
  }

  doSearch() {
    let searchInput = this.searchForm.get('search')?.value || '';
    this.searchValue = searchInput.trim();
    this.searchForm.get('search')?.setValue(this.searchValue, { emitEvent: false });
    
    if (this.searchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/events'], { queryParams: this.queryParams });
    }
  }

  filterChange(value: any) {
    this.selected = value;
    if (value === 'manufacturer') {
      this.usedOnMobile = false;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/events'], { queryParams: this.queryParams });
    } else if (value === 'usedOnMobile') {
      this.usedOnMobile = true;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/events'], { queryParams: this.queryParams });
    }
  }

  addEvent() {
    const dialogRef = this.dialog.open(AddEditEventComponent, {
      disableClose: true,
      width: '600px',
      data: {
        type: 'Add',
      }
    });
    dialogRef.afterClosed().subscribe((newEvent) => {
      if (newEvent) {
        const event  = new Event(newEvent.payload);
        event.id = newEvent.id;
        if (this.user.type === this.utils.userTypes.Manufacturer) {
          this.eventsList.unshift(event);
          this.totalSize = this.totalSize + 1;
          if (this.eventsList.length <= this.pageSize) {
          } else {
            this.eventsList.splice(this.eventsList.length - 1, 1);
          }
        } else {
          if (this.selected === 'usedOnMobile') {
            this.eventsList.unshift(event);
            this.totalSize = this.totalSize + 1;
            if (this.eventsList.length <= this.pageSize) {
            } else {
              this.eventsList.splice(this.eventsList.length - 1, 1);
            }
          }
        }
        this.getEvents();
      }
    });
  }

  editEvent(event: any) {
    const dialogRef = this.dialog.open(AddEditEventComponent, {
      disableClose: true,
      width: '400px',
      data: {
        type: 'Edit',
        event
      }
    });
    dialogRef.afterClosed().subscribe((editedEvent) => {
      if (editedEvent) {
        this.getEvents();
      }
    });
  }

  openEventDetails(event: any) {
    const dialogRef = this.dialog.open(EventDetailsComponent, {disableClose: true, width: '600px', data: {event, selected: this.selected}});
  }

  deleteEvent(id: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Delete',
        page: 'event',
      }
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status) {
        if (status === 'accept') {
          this.dataService.delete('event/DeleteEvent/' + id).then((data: any) => {
            if (data.statusCode === 200) {
              this.eventsList.forEach( (events, index) => {
                if (events.id === id) {
                  this.eventsList.splice(index, 1);
                  if (this.eventsList.length === 0 && this.pageNumber > 1) {
                    this.pageNumber = this.pageNumber - 1;
                    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
                    this.router.navigate(['/events'], { queryParams: this.queryParams });
                  } else {
                    this.getEvents();
                  }
                }
              });
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'Event deleted successfully',
                  buttonText: 'Ok'
                }
              });
            } else {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'Something went wrong, Please try again!',
                  buttonText: 'Ok'
                }
              });
            }
          });
        }
      }
    });
  }

  clearSearch() {
    this.showSearch = !this.showSearch;
    this.searchForm.get('search')?.setValue('');
    this.searchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue,
      usedOnMobile: this.usedOnMobile
    };
    this.router.navigate(['/events'], { queryParams: this.queryParams });
  }

  getEvents() {
    if (this.usedOnMobile ===  null) {
      let url = 'event/RetrieveAllEvents' + '?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.searchValue;

      if (this.user.type === this.utils.userTypes.Manufacturer || this.user.type === this.utils.userTypes.ManufacturerChild) {
        url = 'event/RetrieveAllEvents' + '?pageNumber=' + this.pageNumber +
        '&pageSize=' + this.pageSize +
        '&searchKeyword=' + this.searchValue +
        '&AddedBy=2'
      }
      this.dataService.get(url).then((data: any) => {
        if (data.statusCode === 200) {
          this.eventsList = [];
          const eventsData = data.data.records;
          this.totalSize = data.data.count;
          eventsData.forEach((eventData: any) => {
            const eventInstance = new Event(eventData);
            this.eventsList.push(eventInstance);
          });
          if (eventsData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
            this.router.navigate(['/events'], { queryParams: this.queryParams });
          }
        }
      });
    } else {
      let addedBy = this.usedOnMobile === "true" ? '4' : '2';
      if (this.usedOnMobile === true) {
        addedBy = '4';
      }
      this.dataService.get('event/RetrieveAllEvents?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.searchValue +
      '&usedOnMobile=' + this.usedOnMobile +
      '&AddedBy=' + addedBy).then((data: any) => {
        if (data.statusCode === 200) {
          this.eventsList = [];
          const eventsData = data.data.records;
          this.totalSize = data.data.count;
          eventsData.forEach((eventData: any) => {
            const eventInstance = new Event(eventData);
            this.eventsList.push(eventInstance);
          });
          if (eventsData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
            this.router.navigate(['/events'], { queryParams: this.queryParams });
          }
        }
      });
    }
  }

  exportEvents(fileTypeId: number) {
    this.exportService.exportFile('event/export/AllEvents', fileTypeId, this.searchValue, 'events', { usedOnMobile: this.usedOnMobile, AddedBy: this.usedOnMobile === true ? '4' : '2' } );
  }
}
